import { useEffect, useState } from "react"
import { getDescuentoById, postDescuento, patchDescuento } from "../../services/DescuentosServices"
import { DescuentosFormContext } from "./DescuentosContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Descuento } from '../../routes/RoutesConstants'

export const DescuentosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getDescuentoByIdData(id)
    }, [])

    const getDescuentoByIdData = async (id) => {
        let res = await getDescuentoById(id)
        if (res) setReport(res)
    }

    const postDescuentoData = async (body) => {
        const res = await postDescuento(body)
        
        if (res) navigate("/descuentos");
    }

    const patchDescuentoData = async (id, body) => {
        const res = await patchDescuento(id, body)

        if (res) navigate("/descuentos");
    }


    return <DescuentosFormContext.Provider value={{
        report,
        postDescuentoData,
        patchDescuentoData,
    }} >
        {children}
    </DescuentosFormContext.Provider>
}